import { ServerError } from '@britishcouncil/react-forms';

export const GENERAL_SERVER_ERROR = {
  message: 'Error occurred. Please try again',
};

const keyToCamelCase = (key: string | undefined) => {
  if (!key) return key;
  return key.charAt(0).toLowerCase() + key.slice(1);
};

export interface ServerErrorResponse {
  status: number;
  data?: unknown;
}

export const mapServerError = (serverError: any): ServerError[] => {
  if (!serverError || !serverError.data || !Array.isArray(serverError.data))
    return [GENERAL_SERVER_ERROR];
  return serverError.data.map((x: any) => ({
    message: x.Value,
    propertyName: keyToCamelCase(x.Key),
  }));
};
